import baseStyles from '../Base/Base.styles';
import merge from 'lodash/merge';
import {parseResponsiveProperty} from '@converdy/styles';
import BaseImageStyles from '../BaseImage/BaseImage.styles';
import baseTextStyles from '../BaseText/BaseText.styles';
import SwipeableGridStyles from '../SwipeableGrid/SwipeableGrid.styles';

import {
  responsiveTextAlignment,
  default as responsiveAlignment,
} from '../Base/responsiveAlignment';
import {propertiesToJss as titleJss} from '../BaseTitle/BaseTitle.styles';
import baseButtonStyles from '../BaseButton/BaseButton.styles';

export default ({
  base,
  image,
  spacing = {},
  title = {},
  description = {},
  imagePostition,
  swipeableGrid,
  button,
}) => {
  let jss = {
    root: {
      ...baseStyles(base),
      ...merge(
        parseResponsiveProperty((c) => {
          return c
            ? {
                '--media-spacing': `${c}px`,
              }
            : {};
        }, spacing.image),
        parseResponsiveProperty((c) => {
          return c
            ? {
                '--title-spacing': `${c}px`,
              }
            : {};
        }, spacing.title),
        parseResponsiveProperty((c) => {
          return c
            ? {
                '--cta-spacing': `${c}px`,
              }
            : {};
        }, spacing.button),
      ),
      '& .position-top .media': responsiveTextAlignment(base.alignment),
      '& .media img': {
        ...BaseImageStyles(image),
      },
      '& .description': baseTextStyles(description),
      '& .title': titleJss(title),
      '& .grid-wrapper': SwipeableGridStyles(swipeableGrid),
      '& .cta': baseButtonStyles(button),
    },
  };

  console.log('description', description);

  if (imagePostition !== 'top') {
    merge(jss.root, {
      '& .element-content': responsiveTextAlignment(base.alignment),
    });
  }

  return jss;
};
